import {APP_INITIALIZER, NgModule} from '@angular/core';
import { CommonModule } from '@angular/common';
import { TopicRoutingModule } from './topic-routing.module';
import {FormsModule} from '@angular/forms';
import {DndModule} from 'ng2-dnd';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {NgbModule} from '@ng-bootstrap/ng-bootstrap';
import {NgxChartsModule} from '@swimlane/ngx-charts';
import {SharedModule} from '../shared/shared.module';
import {TopicService} from './topic.service';
import {LanguageProvider} from './language.provider';
import {ExercisesComponent} from './exercises/exercises.component';
import {TopicComponent} from './topic/topic.component';
import {HelpComponent} from './help/help.component';
import { CompletePatternComponent } from './complete-pattern/complete-pattern.component';
import { CompletePatternTwoPlayerComponent } from './complete-pattern-two-player/complete-pattern-two-player.component';
import { CountPatternComponent } from './count-pattern/count-pattern.component';
import { GeneratePatternComponent } from './generate-pattern/generate-pattern.component';
import { CompletePatternContentComponent } from './complete-pattern-content/complete-pattern-content.component';

@NgModule({
  imports: [
    CommonModule,
    TopicRoutingModule,
    FormsModule,
    DndModule,
    BrowserAnimationsModule,
    NgbModule,
    NgxChartsModule,
    SharedModule
  ], providers: [TopicService,
    LanguageProvider,
    { provide: APP_INITIALIZER, useFactory: languageProviderFactory, deps: [LanguageProvider], multi: true }],
  declarations: [
    ExercisesComponent,
    TopicComponent,
    HelpComponent,
    CompletePatternComponent,
    CompletePatternTwoPlayerComponent,
    CountPatternComponent,
    GeneratePatternComponent,
    CompletePatternContentComponent,
  ]
})
export class PatternModule { }

export function languageProviderFactory(provider: LanguageProvider) {
  return () => provider.load();
}
